import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Edit,
  Resize,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import {
  CreateSystemBuildApi,
  GetAllEmployees,
  getSystemBuildItembySoPartId,
  PrintSystemBuildApi,
  PrintSystemBuildBySnApi,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { validateField } from "../../contexts/Utils";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import SelectField from "../../components/SelectField";
import DateInputField from "../../components/DateInputField";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

// DatePicker `open` handler for the pull_date columns. Syncfusion calls it with
// the DatePicker as `this`, so it must stay a regular function.
function fillTodayIfEmpty() {
  if (!this.value) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.value = today;
  }
}

const BuildSheet = () => {
  let param = useParams();
  var so_part_id = param.so_part_id;
  const { currentColor } = useStateContext();
  const [getEmployees, setGetEmployees] = useState([]);
  const [BaseItems, setBaseItems] = useState([]);
  const [CoolItems, setCoolItems] = useState([]);
  const [TestItems, setTestItems] = useState([]);
  const [MacdItems, setMacdItems] = useState([]);
  const [Items, setItems] = useState([]);
  const [index, setIndex] = useState(0);
  const [index1, setIndex1] = useState(0);
  const [total, setTotal] = useState(0);
  // Bumped by Copy Values to rebuild the grids (they may not redraw for [])
  const [copyVersion, setCopyVersion] = useState(0);
  const gridRef1 = useRef(null);
  const gridRef2 = useRef(null);
  const gridRef3 = useRef(null);
  const gridRef4 = useRef(null);
  const { promiseInProgress } = usePromiseTracker();
  const [formData, setFormData] = useState({
    part_id: null,
    so_id: null,
    so_part_id: null,
    customer: "",
    so: "",
    system_sn: "",
    system_pn: "",
    technician: "Select",
    start_date: null,
    detail: "",
    notes: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadBtn, setLoadBtn] = useState(false);

  // Pulled By choice made in the row being edited; handleActionBegin copies it
  // into the row on save. It's kept out of state on purpose: changing the
  // grid's dataSource mid-edit makes Syncfusion refresh and drop the edit.
  const pendingPulled = useRef(null);

  // Uncontrolled (defaultValue) so it shows the choice without a re-render
  const pulledByEditTemplate = (props) => (
    <select
      className="select-custom rounded-xl"
      defaultValue={props.pulled_id || ""}
      onChange={(e) => {
        const id = parseInt(e.target.value) || 0;
        pendingPulled.current = {
          item_id: props.item_id,
          pulled_id: id,
          pulled_by: getEmployees.find((emp) => emp.value === id)?.label || "",
        };
      }}
    >
      <option key="" value="">
        None
      </option>
      {getEmployees.map((item) => (
        <option key={item.value} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );

  const base_items = [
    {
      field: "item_name",
      headerText: "Item",
      minWidth: "100",
      width: "130",
      maxWidth: "140",
      textAlign: "left",
      allowEditing: false,
      isPrimaryKey: true,
    },
    {
      field: "mfg_name",
      headerText: "Manufacturer",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: true,
    },
    {
      field: "mfg_pn",
      headerText: "Mfg PN",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: true,
    },
    {
      field: "xeno_sn",
      headerText: "Xeno SN",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: true,
    },
    {
      field: "quantity",
      headerText: "Qty",
      minWidth: "75",
      width: "85",
      maxWidth: "90",
      textAlign: "center",
      allowEditing: true,
      type: "number", // 👈 IMPORTANT
      editType: "numericedit", // 👈 IMPORTANT
      format: "N0", // 2 decimal places (optional)
      edit: { params: { decimals: 0, min: 0, step: 1 } },
    },
    {
      // field: "pulled_by",
      template: (props) => <label>{props.pulled_by} </label>,
      headerText: "Pulled By",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: true,
      editTemplate: pulledByEditTemplate,
    },
    {
      field: "pull_date",
      headerText: "Date",
      minWidth: "85",
      width: "85",
      maxWidth: "90",
      textAlign: "center",
      editType: "datepickeredit", // 👈 IMPORTANT
      edit: { params: { open: fillTodayIfEmpty } },
      format: "d/M/y", // display format
      type: "date", // 👈 IMPORTANT
    },
  ];

  const cool_items = [
    {
      field: "item_name",
      headerText: "Item",
      minWidth: "100",
      width: "130",
      maxWidth: "140",
      textAlign: "left",
      allowEditing: false,
      isPrimaryKey: true,
    },
    {
      field: "mfg_name",
      headerText: "Manufacturer",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: true,
    },
    {
      field: "mfg_pn",
      headerText: "Mfg PN",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: true,
    },
    {
      field: "xeno_sn",
      headerText: "Xeno SN",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: true,
    },
    {
      field: "quantity",
      headerText: "Qty",
      minWidth: "75",
      width: "85",
      maxWidth: "90",
      textAlign: "center",
      allowEditing: true,
      type: "number", // 👈 IMPORTANT
      editType: "numericedit", // 👈 IMPORTANT
      format: "N0", // 2 decimal places (optional)
      edit: { params: { decimals: 0, min: 0, step: 1 } },
    },
    {
      // field: "pulled_by",
      template: (props) => <label>{props.pulled_by} </label>,
      headerText: "Pulled By",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: true,
      editTemplate: pulledByEditTemplate,
    },
    {
      field: "pull_date",
      headerText: "Date",
      minWidth: "85",
      width: "85",
      maxWidth: "90",
      textAlign: "center",
      editType: "datepickeredit", // 👈 IMPORTANT
      edit: { params: { open: fillTodayIfEmpty } },
      format: "d/M/y", // display format
      type: "date", // 👈 IMPORTANT
    },
  ];

  const test_items = [
    {
      field: "item_name",
      headerText: "Check",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: false,
      isPrimaryKey: true,
    },
    {
      field: "initials",
      headerText: "Initials",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: true,
    },
  ];

  const macd_items = [
    {
      field: "adapter",
      headerText: "Network Adapter",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: false,
      isPrimaryKey: true,
    },
    {
      field: "address",
      headerText: "MAC Address",
      minWidth: "100",
      width: "160",
      maxWidth: "340",
      textAlign: "left",
      allowEditing: true,
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleIndexChange = (e) => {
    const newIndex = parseInt(e.target.value);
    if (!isNaN(newIndex) && newIndex > 0 && newIndex <= total)
      setIndex1(newIndex);
    else
      showErrorToast("Error!", "Index must be a number between 1 and " + total);
  };

  const handleActionBegin = (args) => {
    if (args.requestType === "beginEdit") pendingPulled.current = null;
    if (args.requestType !== "save") return;
    const row = args.data || {};
    // Not cleared here, so the choice survives a save rejected below
    const pending = pendingPulled.current;
    if (pending && row.item_id && pending.item_id === row.item_id) {
      row.pulled_id = pending.pulled_id;
      row.pulled_by = pending.pulled_by;
    }
    const reject = (msg) => {
      args.cancel = true;
      showErrorToast("Error!", msg);
    };
    // Saved systems other than the one on screen (skips unvisited holes)
    const others = Items.filter((s, i) => s && i !== index);

    if (
      !row.item_id &&
      !row.base_item_id &&
      !row.cool_item_id &&
      !row.test_item_id &&
      !row.adapter
    )
      return reject("Network Adapter must have a value!");

    // MAC must be unique in this grid and across all systems
    const mac = (row.address || "").trim().toLowerCase();
    if (mac) {
      const sameMac = (m) => (m.address || "").trim().toLowerCase() === mac;
      const prevMac = (args.previousData?.address || "").trim().toLowerCase();
      // An edited row is still in the grid with its old value; allow that one match
      const allowed = args.action === "edit" && prevMac === mac ? 1 : 0;
      const inGrid = (gridRef4.current?.dataSource || []).filter(
        sameMac,
      ).length;
      if (
        inGrid > allowed ||
        others.some((s) => (s.mac_items || []).some(sameMac))
      )
        return reject("MAC Address must be unique!");
    }

    // Xeno SN must be unique across base + cool rows of all systems
    const sn = (row.xeno_sn || "").trim();
    if (sn && row.quantity !== "-") {
      const sameSn = (r) =>
        r.quantity !== "-" && (r.xeno_sn || "").trim() === sn;
      const isThisRow = (r) =>
        r.item_id === row.item_id && r.item_name === row.item_name;
      const onScreen = [
        ...(gridRef1.current?.dataSource || []),
        ...(gridRef2.current?.dataSource || []),
      ];
      if (
        onScreen.some((r) => !isThisRow(r) && sameSn(r)) ||
        others.some((s) =>
          [...(s.base_items || []), ...(s.cool_items || [])].some(sameSn),
        )
      )
        return reject("Xeno SN must be unique!");
    }
  };

  function getLocDate(pDate) {
    if (!pDate) return null;

    const date = new Date(pDate);
    const pad = (num) => String(num).padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // getMonth() is zero-indexed (0-11)
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
  }

  const toBuildItem = (fields) => ({
    system_id: 0,
    base_item_id: 0,
    cool_item_id: 0,
    test_item_id: 0,
    mac_address: 0,
    mfg_name: "",
    mfg_pn: "",
    xeno_sn: "",
    quantity: 0,
    pulled_by: "",
    item_date: null,
    notes: "",
    ...fields,
  });

  // Flattens a stored system's grid rows into the API's system_build_items
  function buildItemsFor(system) {
    const part = (idKey) => (p) => {
      const used = p.quantity !== "-";
      return toBuildItem({
        [idKey]: p.item_id,
        mfg_name: used ? p.mfg_name : "",
        mfg_pn: used ? p.mfg_pn : "",
        xeno_sn: used ? p.xeno_sn : "",
        quantity: used ? p.quantity : 0,
        pulled_by: used ? p.pulled_by : "",
        item_date: used ? getLocDate(p.pull_date) : null,
      });
    };
    return [
      ...(system.base_items || []).map(part("base_item_id")),
      ...(system.cool_items || []).map(part("cool_item_id")),
      ...(system.test_items || []).map((t) =>
        toBuildItem({ test_item_id: t.item_id, pulled_by: t.initials }),
      ),
      ...(system.mac_items || []).map((m) =>
        toBuildItem({
          mac_address: 1,
          mfg_name: m.adapter,
          pulled_by: m.address,
        }),
      ),
    ];
  }

  // Copies of the rows in the four grids, or null while they aren't mounted
  function readGrids() {
    const grids = [gridRef1, gridRef2, gridRef3, gridRef4].map(
      (r) => r.current,
    );
    if (grids.some((g) => !g)) return null;
    const [base, cool, test, mac] = grids.map((g) =>
      (g.dataSource || []).map((x) => ({ ...x })),
    );
    return {
      base_items: base,
      cool_items: cool,
      test_items: test,
      mac_items: mac,
    };
  }

  // The system on screen (form + grids), or null while the grids are loading
  function currentSystem() {
    const grids = readGrids();
    if (!grids) return null;
    return {
      part_id: formData.part_id || null,
      so_id: formData.so_id || null,
      so_part_id: so_part_id,
      customer: formData.customer || "",
      system_sn: formData.system_sn || "",
      system_pn: formData.system_pn || "",
      notes: formData.notes || "",
      so: "S" + formData.so_id || "",
      start_date: formData.start_date?.split("T")[0] || null,
      technician: formData.technician || null,
      ...grids,
    };
  }

  function validateCurrent() {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return false;
    if (
      formData.system_sn !== "" &&
      Items.some(
        (item, i) => item.system_sn === formData.system_sn && i !== index,
      )
    ) {
      showErrorToast("Error!", "System SN must be unique!");
      return false;
    }
    return true;
  }

  // Same rows as the template system, with every entered value cleared
  function blankSystem(template) {
    const clearPart = (x) => ({
      ...x,
      mfg_name: "",
      mfg_pn: "",
      xeno_sn: "",
      quantity: x.quantity === "-" ? "-" : 0,
      pulled_by: "",
      pulled_id: 0,
      pull_date: null,
    });
    return {
      part_id: template?.part_id || null,
      so_id: template?.so_id || null,
      customer: template?.customer || "",
      system_pn: template?.system_pn || "",
      system_sn: "",
      notes: "",
      start_date: null,
      base_items: (template?.base_items || []).map(clearPart),
      cool_items: (template?.cool_items || []).map(clearPart),
      test_items: (template?.test_items || []).map((x) => ({
        ...x,
        initials: "",
      })),
      mac_items: [],
    };
  }

  // list must be the up-to-date Items array (state may not have updated yet)
  function updateTableData(ind, list) {
    setIndex(ind);
    const itemss = list[ind] ?? blankSystem(list[index]);
    // Copy rows so grid edits don't mutate the stored system
    setBaseItems((itemss.base_items || []).map((x) => ({ ...x })));
    setCoolItems((itemss.cool_items || []).map((x) => ({ ...x })));
    setTestItems((itemss.test_items || []).map((x) => ({ ...x })));
    setMacdItems((itemss.mac_items || []).map((x) => ({ ...x })));
    setFormData((prev) => ({
      ...prev,
      part_id: itemss?.part_id || null,
      so_id: itemss?.so_id || null,
      so_part_id: so_part_id,
      customer: itemss?.customer || "",
      system_sn: itemss?.system_sn || "",
      system_pn: itemss?.system_pn || "",
      notes: itemss?.notes || "",
      so: "S" + itemss?.so_id || "",
      start_date: itemss?.start_date?.split("T")[0] || null,
      technician: itemss?.technician || "Select",
    }));
    return true;
  }

  // Validates and stores the system on screen, then shows system `target`
  function saveCurrentAndGo(target) {
    if (!validateCurrent()) return;
    const current = currentSystem();
    if (!current) return;
    const nextItems = Items.slice(); // slice() keeps unvisited systems as holes
    nextItems[index] = current;
    setItems(nextItems);
    updateTableData(target, nextItems);
  }

  const handleSearchClick = (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    if (!isNaN(index1) && index1 > 0 && index1 <= total)
      saveCurrentAndGo(index1 - 1);
  };

  const handlePrintClick = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    try {
      if (!validateCurrent()) return;
      if (formData.system_sn === "") {
        showErrorToast("Error!", "System SN is required!");
        return;
      }
      const current = currentSystem();
      if (!current) return;
      const allSystems = Items.slice();
      allSystems[index] = current;
      // filter(Boolean) drops systems that were never opened
      const systems = allSystems.filter(Boolean).map((item) => ({
        part_id: item.part_id,
        so_id: item.so_id,
        so_part_id: item.so_part_id,
        employee_id: item.technician?.value,
        system_sn: item.system_sn || "",
        system_pn: item.system_pn || "",
        start_date: item.start_date,
        detail: item.detail || "",
        notes: item.notes,
        system_build_items: buildItemsFor(item),
      }));
      const response = await CreateSystemBuildApi(systems);
      if (response.success) {
        const resp = await PrintSystemBuildBySnApi(
          formData.so_part_id,
          formData.system_sn,
        );
        if (resp)
          showSuccessToast("Success!", "System build printed successfully!");
        window.location.reload();
      } else
        showErrorToast(
          "Error!",
          "System build failed to create!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "System build failed to create!");
    } finally {
      setLoadBtn(false);
    }
  };

  const handleNextClick = (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    saveCurrentAndGo(index + 1);
  };

  const handleBackClick = (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    saveCurrentAndGo(index - 1);
  };

  // Copies System 1's table values onto the system on screen (form fields are
  // left alone). Xeno SN and MAC address are left blank: they must be unique.
  const handleCopyClick = (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    const source = Items[0];
    const current = readGrids();
    if (index === 0 || !source || !current) return;
    const partHasValue = (x) =>
      x.mfg_name ||
      x.mfg_pn ||
      x.xeno_sn ||
      Number(x.quantity) > 0 ||
      x.pulled_by ||
      x.pull_date;
    const hasValues =
      current.base_items.some(partHasValue) ||
      current.cool_items.some(partHasValue) ||
      current.test_items.some((x) => x.initials) ||
      current.mac_items.length > 0;
    if (
      hasValues &&
      !window.confirm(
        `Replace the table values of System # ${index + 1} with System # 1's?`,
      )
    )
      return;
    const copyPart = (x) => ({ ...x, xeno_sn: "" });
    setBaseItems((source.base_items || []).map(copyPart));
    setCoolItems((source.cool_items || []).map(copyPart));
    setTestItems((source.test_items || []).map((x) => ({ ...x })));
    setMacdItems((source.mac_items || []).map((x) => ({ ...x, address: "" })));
    setCopyVersion((v) => v + 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    try {
      if (!validateCurrent()) return;
      const current = currentSystem();
      if (!current) return;
      const allSystems = Items.slice();
      allSystems[index] = current;
      // filter(Boolean) drops systems that were never opened
      const systems = allSystems.filter(Boolean).map((item) => ({
        part_id: item.part_id,
        so_id: item.so_id,
        so_part_id: item.so_part_id,
        employee_id: item.technician?.value,
        system_sn: item.system_sn || "",
        system_pn: item.system_pn || "",
        start_date: item.start_date,
        detail: item.detail || "",
        notes: item.notes,
        system_build_items: buildItemsFor(item),
      }));
      const response = await CreateSystemBuildApi(systems);
      if (response.success) {
        showSuccessToast("Success!", "System build saved successfully!");
        window.location.reload();
      } else
        showErrorToast(
          "Error!",
          "System build failed to create!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "System build failed to create!");
    } finally {
      setLoadBtn(false);
    }
  };

  const handlePrintAllClick = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    try {
      if (!validateCurrent()) return;
      const current = currentSystem();
      if (!current) return;
      const allSystems = Items.slice();
      allSystems[index] = current;
      // filter(Boolean) drops systems that were never opened
      const systems = allSystems.filter(Boolean).map((item) => ({
        part_id: item.part_id,
        so_id: item.so_id,
        so_part_id: item.so_part_id,
        employee_id: item.technician?.value,
        system_sn: item.system_sn || "",
        system_pn: item.system_pn || "",
        start_date: item.start_date,
        detail: item.detail || "",
        notes: item.notes,
        system_build_items: buildItemsFor(item),
      }));
      const response = await CreateSystemBuildApi(systems);
      if (response.success) {
        const resp = await PrintSystemBuildApi(formData.so_part_id);
        if (resp)
          showSuccessToast("Success!", "System build printed successfully!");
        window.location.reload();
      } else
        showErrorToast(
          "Error!",
          "System build failed to create!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "System build failed to create!");
    } finally {
      setLoadBtn(false);
    }
  };

  const handleExitClick = () => {
    window.close();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const grid1 = gridRef1.current;
      if (!grid1) return;
      const grid2 = gridRef2.current;
      if (!grid2) return;
      const grid3 = gridRef3.current;
      if (!grid3) return;
      const grid4 = gridRef4.current;
      if (!grid4) return;

      const gridElement1 = grid1.element;
      const gridElement2 = grid2.element;
      const gridElement3 = grid3.element;
      const gridElement4 = grid4.element;

      if (!gridElement1.contains(event.target)) {
        const isPopup = document.querySelector(".e-popup-open");
        if (grid1.isEdit && !isPopup) grid1.endEdit(); // ✅ auto save
      }
      if (!gridElement2.contains(event.target)) {
        const isPopup = document.querySelector(".e-popup-open");
        if (grid2.isEdit && !isPopup) grid2.endEdit(); // ✅ auto save
      }
      if (!gridElement3.contains(event.target)) {
        const isPopup = document.querySelector(".e-popup-open");
        if (grid3.isEdit && !isPopup) grid3.endEdit(); // ✅ auto save
      }
      if (!gridElement4.contains(event.target)) {
        const isPopup = document.querySelector(".e-popup-open");
        if (grid4.isEdit && !isPopup) grid4.endEdit(); // ✅ auto save
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (!so_part_id) return;
      var emptypes = [];
      await GetAllEmployees()
        .then((resp) => {
          emptypes = resp.data.map((item) => ({
            label: item.name,
            value: item.employee_id,
          }));
          setGetEmployees(emptypes || []);
        })
        .catch((err) => console.log(err.message));
      trackPromise(
        getSystemBuildItembySoPartId(so_part_id)
          .then((resp) => {
            if (resp.data.length === 0) return;
            const toPartRow = (idKey) => (item) => ({
              item_name: item.item_name || "",
              item_id: item[idKey],
              mfg_name: item.mfg_name || "",
              mfg_pn: item.mfg_pn || "",
              xeno_sn: item.xeno_sn || "",
              quantity: item.quantity || 0,
              pulled_by: item.pulled_by || "",
              pulled_id:
                emptypes.find((emp) => emp.label === item.pulled_by)?.value ||
                0,
              pull_date: item.item_date || null,
            });
            const itemss = resp.data.map((system) => ({
              part_id: system.part_id || null,
              so_id: system.so_id || null,
              so_part_id: so_part_id,
              customer: system.customer || "",
              system_sn: system.system_sn || "",
              system_pn: system.system_pn || "",
              notes: system.notes || "",
              so: "S" + system.so_id || "",
              start_date: system.start_date?.split("T")[0] || null,
              // "select" also covers an employee_id that's no longer in the list
              technician:
                (system.employee_id &&
                  emptypes.find((item) => item.value === system.employee_id)) ||
                "select",
              base_items: (system.base_items || []).map(
                toPartRow("base_item_id"),
              ),
              cool_items: (system.cool_items || []).map(
                toPartRow("cool_item_id"),
              ),
              test_items: (system.test_items || []).map((item) => ({
                item_name: item.item_name || "",
                item_id: item.test_item_id,
                initials: item.pulled_by || "",
              })),
              mac_items: (system.mac_items || []).map((item) => ({
                adapter: item.item_name || "",
                address: item.xeno_sn || "",
              })),
            }));

            const first = itemss[0];
            setBaseItems(first.base_items.map((x) => ({ ...x })));
            setCoolItems(first.cool_items.map((x) => ({ ...x })));
            setTestItems(first.test_items.map((x) => ({ ...x })));
            setMacdItems(first.mac_items.map((x) => ({ ...x })));
            setFormData((prev) => ({
              ...prev,
              part_id: first.part_id,
              so_id: first.so_id,
              so_part_id: so_part_id,
              customer: first.customer,
              system_sn: first.system_sn,
              system_pn: first.system_pn,
              notes: first.notes,
              so: first.so,
              start_date: first.start_date,
              technician: first.technician,
            }));
            setTotal(resp.data[0].quantity || 0);
            setItems(itemss);
          })
          .catch((err) => console.log(err.message))
          .finally(() => setLoading(false)),
      );
    }
    fetchData();
  }, [so_part_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="BUILD SHEET" />
      <form>
        <Container className="g-0 pl-8 pr-8" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={3} xl={3} className="container-col">
              <label className="label mt-2">{`Customer: ${formData.customer}`}</label>
            </Col>
            <Col md={4} xl={6} className="container-col">
              <label className="label mt-2">{`Sales Order # ${formData.so}`}</label>
            </Col>
            <Col md={5} xl={3} className="container-col">
              <label
                className="text-lg font-bold m-0"
                style={{ color: currentColor }}
              >
                System # {index + 1}/{total}
              </label>
              <input
                type="number"
                className="input"
                name="index1"
                value={index1}
                onChange={handleIndexChange}
                placeholder="Index"
                style={{ height: "32px", width: "60px", marginLeft: "10px" }}
              />
              <button
                type="button"
                onClick={handleSearchClick}
                className="px-2.5 py-1 ml-2 text-sm text-white rounded-md hover:drop-shadow-xl transition disabled:cursor-not-allowed"
                disabled={promiseInProgress}
                style={{ backgroundColor: currentColor }}
              >
                Search
              </button>
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={3} className="container-col">
              <TextInputField
                label="System P/N:"
                name="system_pn"
                value={formData.system_pn}
                onChange={handleChange}
                placeholder="System P/N"
                // compulsory={true}
                error={errors.system_pn}
              />
            </Col>
            <Col md={3} className="container-col">
              <TextInputField
                label="System S/N:"
                name="system_sn"
                value={formData.system_sn}
                onChange={handleChange}
                placeholder="System S/N"
                // compulsory={true}
                error={errors.system_sn}
              />
            </Col>
            <Col md={3} className="container-col">
              <SelectField
                label="Technician:"
                name="technician"
                value={formData.technician}
                options={getEmployees}
                onChange={handleSelectChange}
                placeholder="Technician"
                // compulsory={true}
                error={errors.technician}
              />
            </Col>
            <Col md={3} className="container-col">
              <DateInputField
                label="Start Date:"
                name="start_date"
                value={formData.start_date}
                onChange={handleChange}
                placeholder="Start Date"
                // compulsory={true}
                error={errors.start_date}
              />
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={8} className="container-col">
              <Row xs={1} sm={1} className="p-0 justify-content-center mt-3">
                <Col md={6} className="container-col">
                  <div className="form-group text-xl pr-4">
                    <b style={{ color: currentColor }}>BASE ITEMS</b>
                  </div>
                </Col>
                <Col md={6} className="container-col text-end">
                  <button
                    type="button"
                    onClick={handleCopyClick}
                    className="px-2.5 py-1 mr-2 text-sm text-white rounded-md hover:drop-shadow-xl transition disabled:cursor-not-allowed"
                    disabled={
                      loadBtn || promiseInProgress || index === 0 || !Items[0]
                    }
                    style={{ backgroundColor: currentColor }}
                  >
                    Copy Values
                  </button>
                </Col>
                {loading || promiseInProgress ? (
                  <LoadingIndicator />
                ) : (
                  <GridComponent
                    key={`${index}-${copyVersion}`}
                    ref={gridRef1}
                    className="custom-grid1"
                    rowHeight={20}
                    dataSource={BaseItems || []}
                    // height="calc(62vh - 60px)"
                    allowResizing
                    // rowSelected={handleRowSelected}
                    editSettings={{ allowEditing: true, mode: "Normal" }}
                    actionBegin={handleActionBegin}
                  >
                    <ColumnsDirective>
                      {base_items.map((item, index) => (
                        <ColumnDirective key={index} {...item} />
                      ))}
                    </ColumnsDirective>
                    <Inject services={[Resize, Edit]} />
                  </GridComponent>
                )}
              </Row>
              <Row xs={1} sm={1} className="p-0 justify-content-center mt-3">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>COOLING ITEMS</b>
                </div>
                {loading || promiseInProgress ? (
                  <LoadingIndicator />
                ) : (
                  <GridComponent
                    key={`${index}-${copyVersion}`}
                    ref={gridRef2}
                    className="custom-grid1"
                    rowHeight={20}
                    dataSource={CoolItems || []}
                    // height="calc(62vh - 60px)"
                    allowResizing
                    // rowSelected={handleRowSelected}
                    editSettings={{ allowEditing: true, mode: "Normal" }}
                    actionBegin={handleActionBegin}
                    // actionComplete={handleActionComplete}
                  >
                    <ColumnsDirective>
                      {cool_items.map((item, index) => (
                        <ColumnDirective key={index} {...item} />
                      ))}
                    </ColumnsDirective>
                    <Inject services={[Resize, Edit]} />
                  </GridComponent>
                )}
              </Row>
            </Col>
            <Col md={4} className="container-col">
              <Row xs={1} sm={1} className="p-0 justify-content-center mt-3">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>INSPECTION & TESTING</b>
                </div>
                {loading || promiseInProgress ? (
                  <LoadingIndicator />
                ) : (
                  <GridComponent
                    key={`${index}-${copyVersion}`}
                    ref={gridRef3}
                    className="custom-grid1"
                    rowHeight={20}
                    dataSource={TestItems || []}
                    // height="calc(62vh - 60px)"
                    allowResizing
                    // rowSelected={handleRowSelected}
                    editSettings={{ allowEditing: true, mode: "Normal" }}
                    actionBegin={handleActionBegin}
                  >
                    <ColumnsDirective>
                      {test_items.map((item, index) => (
                        <ColumnDirective key={index} {...item} />
                      ))}
                    </ColumnsDirective>
                    <Inject services={[Resize, Edit]} />
                  </GridComponent>
                )}
              </Row>
              <Row xs={1} sm={1} className="p-0 justify-content-center mt-3">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>MAC ADDRESS</b>
                </div>
                {loading || promiseInProgress ? (
                  <LoadingIndicator />
                ) : (
                  <GridComponent
                    key={`${index}-${copyVersion}`}
                    ref={gridRef4}
                    className="custom-grid1"
                    rowHeight={20}
                    dataSource={MacdItems || []}
                    // height="calc(62vh - 60px)"
                    allowResizing
                    // rowSelected={handleRowSelected}
                    editSettings={{
                      allowEditing: true,
                      allowAdding: true,
                      allowDeleting: true,
                      mode: "Normal",
                    }}
                    actionBegin={handleActionBegin}
                    toolbar={["Add", "Edit", "Delete", "Update", "Cancel"]}
                  >
                    <ColumnsDirective>
                      {macd_items.map((item, index) => (
                        <ColumnDirective key={index} {...item} />
                      ))}
                    </ColumnsDirective>
                    <Inject services={[Resize, Edit, Toolbar]} />
                  </GridComponent>
                )}
              </Row>
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <TextAreaField
              label="Note:"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Notes"
              error={errors.notes}
            />
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-4">
        <Button
          margin="10px"
          padding="20px"
          text="Print"
          loadingText="Print"
          onClick={handlePrintClick}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Next"
          loadingText="Next"
          onClick={handleNextClick}
          disabled={loadBtn || promiseInProgress || index + 1 === total}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          loadingText="Back"
          onClick={handleBackClick}
          disabled={loadBtn || promiseInProgress || index === 0}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Save All"
          loadingText="Save All"
          onClick={handleSubmit}
          disabled={
            loadBtn || promiseInProgress
            // ||
            // Items.some(
            //   (item, i) =>
            //     (!item.system_sn || !item.technician?.value) && i !== index,
            // )
          }
        />
        <Button
          margin="10px"
          padding="20px"
          text="Print All"
          loadingText="Print All"
          onClick={handlePrintAllClick}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Exit"
          loadingText="Exit"
          onClick={handleExitClick}
          disabled={loadBtn}
        />
      </Row>
    </div>
  );
};

export default BuildSheet;
